import * as React from 'react';
import { StyledHTMLElement } from 'styletron-react';
import { styled } from 'styletron-react';

export const ContentStyle: React.CSSProperties = {
    margin: 8,
    position: 'relative',
};

export const Content = styled('div', ContentStyle);



// WEBPACK FOOTER //
// ./primitives/Content.tsx